import swal from 'sweetalert';
import { Link } from 'react-router-dom';

import { InfoMessage, Button } from 'sso/components/common';

export const MigrateWarning = ({ location }) => {
  const { signUpUrl } = location.state;

  const onMigrateNow = async () => {
    const canContinue = await swal({
      title: 'Migrate Now!',
      text: 'To migrate, create a Roland Account with a valid email. It\'s that easy!',
      buttons: {
        continue: { text: 'Continue to Account Creation', value: true, className: 'bg-blue' },
        cancel: 'Back',
      },
    });
    if (canContinue) {
      window.location.href = signUpUrl;
    }
  };

  return (
    <div className='center mw6'>
      <div className='min-vh-100 flex flex-column'>
        <div className='mh4 mw5 mv3 flex-auto self-center flex flex-column items-center justify-center' style={{ maxHeight: 250 }}>
          <img className='mw3 mb4' src={require('assets/img/music-logo.png')} style={{ objectFit: 'contain' }} alt='music logo' />
          <img className='mw5' src={require('assets/img/logo-plain.png')} style={{ objectFit: 'contain' }} alt='logo plain' />
        </div>
        <div className='mh4 flex flex-column'>
          <InfoMessage style={{ fontSize: 18, textAlign: 'center' }} message='Notice: Your Roland Cloud membership is now a part of Roland Account. Please click the button below to migrate your existing Roland Cloud account to a new or existing Roland Account. Don’t worry, your Roland Cloud subscription won’t be affected.' />
          <Link className='pointer mid-gray no-underline dim link mb3 self-center' to='/'>Back to login</Link>
        </div>
        <div className='mh4 flex flex-column'>
          <Button color='green' className='br2 pointer w-100 white bn link pv3 mv2' onClick={onMigrateNow}>Migrate Now</Button>
        </div>
      </div>
    </div>
  );
};
